import { defineComponent as i, openBlock as t, createElementBlock as o, mergeProps as u, unref as e, renderSlot as g, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as V } from "../hooks/useScalarIcon.js";
const f = { key: 0 }, h = { key: 1 }, w = { key: 2 }, k = { key: 3 }, M = { key: 4 }, Z = { key: 5 }, y = {
  name: "ScalarIconArrowDown"
}, L = /* @__PURE__ */ i({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = V(s);
    return (p, l) => (t(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      g(p.$slots, "default"),
      e(a) === "bold" ? (t(), o("g", f, l[0] || (l[0] = [
        n("path", { d: "M208.49,152.49l-72,72a12,12,0,0,1-17,0l-72-72a12,12,0,0,1,17-17L116,187V40a12,12,0,0,1,24,0V187l51.51-51.52a12,12,0,0,1,17,17Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (t(), o("g", h, l[1] || (l[1] = [
        n("path", {
          d: "M200,144l-72,72L56,144Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M207.39,140.94A8,8,0,0,0,200,136H136V40a8,8,0,0,0-16,0v96H56a8,8,0,0,0-5.66,13.66l72,72a8,8,0,0,0,11.32,0l72-72A8,8,0,0,0,207.39,140.94ZM128,204.69,75.31,152H180.69Z" }, null, -1)
      ]))) : e(a) === "fill" ? (t(), o("g", w, l[2] || (l[2] = [
        n("path", { d: "M205.66,149.66l-72,72a8,8,0,0,1-11.32,0l-72-72A8,8,0,0,1,56,136h64V40a8,8,0,0,1,16,0v96h64a8,8,0,0,1,5.66,13.66Z" }, null, -1)
      ]))) : e(a) === "light" ? (t(), o("g", k, l[3] || (l[3] = [
        n("path", { d: "M204.24,148.24l-72,72a6,6,0,0,1-8.48,0l-72-72a6,6,0,0,1,8.48-8.48L122,201.51V40a6,6,0,0,1,12,0V201.51l61.76-61.75a6,6,0,0,1,8.48,8.48Z" }, null, -1)
      ]))) : e(a) === "regular" ? (t(), o("g", M, l[4] || (l[4] = [
        n("path", { d: "M205.66,149.66l-72,72a8,8,0,0,1-11.32,0l-72-72a8,8,0,0,1,11.32-11.32L120,196.69V40a8,8,0,0,1,16,0V196.69l58.34-58.35a8,8,0,0,1,11.32,11.32Z" }, null, -1)
      ]))) : e(a) === "thin" ? (t(), o("g", Z, l[5] || (l[5] = [
        n("path", { d: "M202.83,146.83l-72,72a4,4,0,0,1-5.66,0l-72-72a4,4,0,0,1,5.66-5.66L124,206.34V40a4,4,0,0,1,8,0V206.34l65.17-65.17a4,4,0,0,1,5.66,5.66Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  L as default
};
